var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 32H64C28.654 32 0 60.654 0 96V416C0 451.346 28.654 480 64 480H384C419.348 480 448 451.346 448 416V96C448 60.654 419.348 32 384 32ZM352 360C352 373.25 341.25 384 328 384S304 373.25 304 360V226.219L243.453 310.047C234.422 322.547 213.578 322.547 204.547 310.047L144 226.219V360C144 373.25 133.25 384 120 384S96 373.25 96 360V152C96 141.594 102.719 132.359 112.609 129.172C122.469 125.922 133.359 129.484 139.453 137.953L224 255.016L308.547 137.953C314.641 129.484 325.437 125.922 335.391 129.172C345.281 132.359 352 141.594 352 152V360Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareM);
export default __webpack_public_path__ + "static/media/square-m.e775b96ca8c9a72cacf252285deb15fd.svg";
export { ForwardRef as ReactComponent };